import { FC } from "react"
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const CircleIcon: FC<MoodIconProps> = ({
  x,
  y,
  backgroundColor,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return <FiberManualRecordIcon style={{ color: backgroundColor }} />
}

export default CircleIcon
